<template>
  <v-app light>
    <v-toolbar class="primary" dark height="75">
      <div class="pl-sm-12 d-flex align-center">
        <SvgIcon icon="cp-logo-1" height="60px" fill="white"></SvgIcon>
      </div>
      <v-spacer></v-spacer>
      <PractitionerLoggedToolbarBox
        v-if="isLoggedIn"
      ></PractitionerLoggedToolbarBox>
      <v-btn outlined rounded to="ingresar" v-else large class="mr-md-12"
        >Ingresar</v-btn
      >
    </v-toolbar>
    <v-content>
      <!-- Home -->
      <section
        style="height: 720px; position: relative; overflow: hidden;"
        class="d-flex align-center"
      >
        <v-img
          :src="jureles"
          style="position:absolute;top:0; width: 100%; height: 100%"
          gradient="to top right, rgba(12,28,38,.76), rgba(25,53,71,.4)"
        ></v-img>
        <v-row class="pa-4 ma-0 pl-md-12 pr-md-12 pt-12 pb-12">
          <v-col cols="12" md="5" class="ml-auto">
            <v-card color="transparent" flat class="white--text">
              <div class="display-1">
                <p class="font-weight-bold" style="max-width: 390px;">
                  <span style="color: #c0e2e6">
                    Plataforma colaborativa
                  </span>
                  de buzos y pescadores deportivos y artesanales
                </p>
              </div>
              <p>
                <span class="body-1 primary--text font-weight-bold">
                  REGISTRO · COLABORACIÓN · CIENCIA CIUDADANA
                </span>
              </p></v-card
            >
          </v-col>
          <v-col cols="12" md="5" class="mr-auto">
            <LandingIndicators></LandingIndicators>
            <div class="d-flex justify-center" v-if="!isLoggedIn">
              <v-btn
                color="primary"
                dark
                to="ingresar"
                rounded
                large
                class="pl-8 pr-8"
                >Regístrate</v-btn
              >
            </div>
          </v-col>
        </v-row>
      </section>

      <!-- Biblioteca -->
      <section style="background: #faebd76b;">
        <LibraryLanding></LibraryLanding>
      </section>

      <!-- Material educativo -->
      <section class="primary pt-12 pb-12" style="position: relative">
        <v-img
          :src="robalo"
          height="100"
          width="280"
          contain
          style="position:absolute; top: 40px; right: 0; filter: opacity(20%)"
        ></v-img>

        <v-img
          :src="chancharro"
          height="350"
          width="480"
          contain
          style="position:absolute; bottom: 90px; left: -250px; transform: scaleX(-1); filter: opacity(20%)"
        ></v-img>
        <p
          class="display-1 text-center font-weight-bold mb-12"
          style="color: #c0e2e6;"
        >
          Descarga nuestro material educativo
        </p>

        <v-row no-gutters>
          <v-col cols="12" sm="6" md="4" class="pa-2 mr-md-8 ml-auto">
            <v-card color="secondary" dark height="100%">
              <v-img :src="libro_peces" height="200px" full-width></v-img>
              <v-card-text class="pa-md-8">
                <p class="title" style="color: #c0e2e6;">Libro peces de roca</p>
                <p class="body-1 font-weight-medium white--text">
                  Este trabajo es producto de la colaboración de expertos
                  académicos, de instituciones del estado, federaciones de pesca
                  recreativa y ONGs. Santiago de Chile, 2020
                </p>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  fab
                  bottom
                  right
                  absolute
                  small
                  href="https://www.costahumboldt.org/wp-content/uploads/2020/05/Librillo-Peces-Litorales-de-Chile-II.pdf"
                  target="_blank"
                  class="mb-8"
                >
                  <v-icon>mdi-download</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="4" class="pa-2 ml-md-8 mr-auto">
            <v-card color="secondary" dark height="100%">
              <v-img :src="tablilla_peces" height="200px" full-width></v-img>
              <v-card-text class="pa-md-8">
                <p class="title" style="color: #c0e2e6;">
                  Tablilla buceo recreativo
                </p>
                <p class="body-1 font-weight-medium white--text">
                  Acompaña tus buceos con esta tablilla de identificación de
                  peces de roca, y anota tus registros y observaciones mientras
                  buceas
                </p>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  fab
                  bottom
                  right
                  absolute
                  small
                  href="https://www.costahumboldt.org/wp-content/uploads/2020/05/Tablilla-Peces.pdf"
                  target="_blank"
                  class="mb-8"
                >
                  <v-icon>mdi-download</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </section>

      <!-- Sobre el proyecto -->
      <section style="position: relative; overflow: hidden;">
        <v-img
          :src="vieja_tiuque"
          height="280"
          width="400"
          contain
          style="position:absolute; top: 0px; right: -90px; filter: opacity(20%)"
        ></v-img>

        <v-row no-gutters class="pl-4 pr-4 mb-10 mx-auto mt-8">
          <v-col cols="12" md="11" class="ml-auto">
            <v-card max-width="600" class="mr-auto" color="transparent" flat>
              <div class="text-left mb-2">
                <h2 class="display-1 primary--text font-weight-bold">
                  Sobre el proyecto
                </h2>
              </div>
              <p class="body-1 secondary--text font-weight-medium text-left">
                Somos una plataforma colaborativa que invita a participar a
                buzos deportivos, pescadores y ciudadanía en el levantamiento de
                información sobre la distribución y abundancia de peces de roca,
                fauna y flora marina bentónica de las costas de Chile.
              </p>
            </v-card>
          </v-col>
        </v-row>
      </section>

      <!-- Nuestro objetivo -->
      <section>
        <v-row no-gutters class="pl-4 pr-4 mb-10 mx-auto">
          <v-col cols="12" md="4" lg="2" class="ml-auto">
            <v-card class="primary pa-6" dark flat tile height="100%">
              <p class="title font-weight-bold">NUESTRO OBJETIVO</p>
              <p class="body-2">
                Buscamos integrar la ciencia ciudadana en el desarrollo de
                contenido que permita
                <span class="font-weight-medium">
                  representar, difundir y proteger la biodiversidad
                  costero-marina
                </span>
                del sistema de corrientes de Humboldt y Cabo de Hornos, e islas
                oceánicas de Chile.
              </p>
            </v-card>
          </v-col>
          <v-col cols="12" md="4" lg="2" class="d-none d-lg-flex">
            <v-img :src="IMG_2722" height="auto"></v-img>
          </v-col>
          <v-col cols="12" md="4" lg="2">
            <v-card class="secondary pa-6" dark flat tile height="100%">
              <p class="title font-weight-bold">CIENCIA CIUDADANA</p>
              <p class="body-2">
                Tus registros son información de alto valor educativo,
                científico y significativo para la conservación de ecosistemas
                costeros y especies vulnerables.
              </p>
            </v-card>
          </v-col>
          <v-col cols="12" md="4" lg="2" class="d-none d-lg-flex">
            <v-img :src="FOC_1462" height="auto"></v-img>
          </v-col>
          <v-col cols="12" md="4" lg="2" class="mr-auto">
            <v-card class="pa-6" color="#004f68" dark flat tile height="100%">
              <p class="title font-weight-bold">TE INVITAMOS A</p>
              <p class="body-2">
                Compartir tus experiencias y avistamientos realizados.
              </p>
              <p class="body-2">
                Descubrir información de las especies que habitan el fondo
                marino, las costas e islas oceánicas de Chile.
              </p>
              <p class="body-2">
                Revisar reportes interactivos de biodiversidad en distintas
                zonas de nuestro país.
              </p>
            </v-card>
          </v-col>
        </v-row>
      </section>

      <!-- Quienes somos -->
      <section style="height: 680px; position: relative; overflow: hidden;">
        <v-img
          :src="quienes_somos"
          style="position: absolute; width: 100%; height: 100%;"
        ></v-img>

        <v-row no-gutters class="mt-10 mr-md-12">
          <v-col cols="12" sm="8" md="4" class="ml-auto mr-md-12">
            <v-card flat color="transparent" class="pt-12" dark>
              <v-card-text>
                <SvgIcon icon="cp-logo-2" height="80px" fill="white"></SvgIcon>
                <div class="pl-2">
                  <p
                    class="display-1 font-weight-bold pt-8"
                    style="color: #c0e2e6;"
                  >
                    Quiénes Somos
                  </p>
                  <p class="font-weight-medium body-1 white--text">
                    Esta plataforma es desarrollada por
                    <span class="font-weight-bold">Costa Humboldt</span> en
                    colaboración con
                    <span class="font-weight-bold">
                      The Nature Conservancy y Center of Applied Ecology &
                      Sustainability (CAPES)
                    </span>
                    , quienes, junto a científicos, buzos y diversos usuarios
                    aportan con contenido actualizado sobre biodiversidad
                    costero-marina de Chile.
                  </p>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </section>

      <!-- Desarrollan -->
      <section>
        <v-container grid-list-md>
          <p
            class="display-1 font-weight-bold primary--text text-center pb-10 pt-10"
          >
            Desarrollan
          </p>
          <v-row class="mb-10">
            <v-col cols="12" md="4">
              <v-card color="transparent" flat height="100%">
                <v-img :src="costahumbold" height="60" contain></v-img>
                <v-card-text
                  class="body-1 primary--text font-weight-medium pl-8 pr-8"
                >
                  Organización sin fines de lucro cuya misión es la promoción,
                  desarrollo e implementación de programas de preservación y
                  conservación de la diversidad biológica y cultural costero
                  marina.
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    rounded
                    outlined
                    href="http://www.costahumboldt.org/"
                    target="_blank"
                    >Ver más</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
              <v-card color="transparent" flat height="100%">
                <v-img :src="tnc" height="60" contain></v-img>
                <v-card-text
                  class="body-1 primary--text font-weight-medium pl-8 pr-8"
                >
                  Organización ambiental global dedicada a la conservación de
                  las tierras y aguas de las cuales depende la vida. Guiados por
                  la ciencia, creamos soluciones innovadoras y prácticas a los
                  desafíos más urgentes de nuestro mundo para que la naturaleza
                  y las personas puedan prosperar juntos.
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    rounded
                    outlined
                    href="https://www.nature.org/es-us/sobre-tnc/donde-trabajamos/tnc-en-latinoamerica/chile/"
                    target="_blank"
                    >Ver más</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
              <v-card color="transparent" flat height="100%">
                <v-img :src="capes" height="60" contain></v-img>
                <v-card-text
                  class="body-1 primary--text font-weight-medium pl-8 pr-8"
                >
                  Centro de investigación científica y tecnológica de excelencia
                  cuya misión de CAPES es llevar a cabo investigación aplicada
                  en temas ambientales relevantes para el desarrollo sostenible
                  de Chile.
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    rounded
                    outlined
                    href="http://www.capes.cl/"
                    target="_blank"
                    >Ver más</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </section>

      <v-footer class="primary darken-2 d-flex justify-center" height="120">
        <SvgIcon icon="cp-logo-2" height="50px" fill="white"></SvgIcon>
      </v-footer>
      <PwaRefresh></PwaRefresh>
    </v-content>
  </v-app>
</template>

<script>
import LandingIndicators from "../LandingPage/LandingIndicators";
import SvgIcon from "@/components/SvgIcon";
import PractitionerAvatar from "@/components/Practitioner/PractitionerAvatar";
import PractitionerLoggedToolbarBox from "@/components/Practitioner/PractitionerLoggedToolbarBox";
import LibraryLanding from "@/components/Library/LibraryLanding";
import PwaRefresh from "@/components/PwaRefresh";

export default {
  name: "App",
  components: {
    LandingIndicators,
    SvgIcon,
    PractitionerAvatar,
    LibraryLanding,
    PractitionerLoggedToolbarBox,
    PwaRefresh,
  },
  data: function() {
    return {
      title: "CostaPez",
      menuPractitioner: false,
      jureles: require("@/assets/landing/jureles.jpg"),
      material_libro:
        "https://www.costahumboldt.org/wp-content/uploads/2020/05/libro.jpg",
      material_tablilla:
        "https://www.costahumboldt.org/wp-content/uploads/2020/05/tablilla.jpg",
      /*       landingImg: [
        {
          src: require("@/assets/landing/IMG_0502.jpg")
        },
        {
          src: require("@/assets/landing/IMG_1114.jpg")
        },
        {
          src: require("@/assets/landing/IMG_2616.jpg")
        },
        {
          src: require("@/assets/landing/IMG_2556.jpg")
        },
        {
          //src: require("@/assets/landing/castañetas.jpg")
        }
      ], */
      costahumbold: require("@/assets/colaboradores/costahumboldt.png"),
      tnc: require("@/assets/colaboradores/tnc-logo.svg"),
      capes: require("@/assets/colaboradores/logowebcapes.png"),
      quienes_somos: require("@/assets/CP_foto-inicio-ondas.png"),
      IMG_2722: require("@/assets/landing/IMG_2722.jpg"),
      FOC_1462: require("@/assets/landing/FOC_1462.jpg"),
      robalo: require("@/assets/landing/robalo.png"),
      chancharro: require("@/assets/landing/chancharro.png"),
      libro_peces: require("@/assets/landing/libro_peces.png"),
      tablilla_peces: require("@/assets/landing/tablilla_peces.png"),
      vieja_tiuque: require("@/assets/landing/15_Vieja tiuque. Borde mejorado (A.pictus).png"),
    };
  },
  computed: {
    imgHeight: function() {
      var offset = 320;
      console.log("new image height is " + (this.pageHeight - offset));
      return this.pageHeight - offset;
    },
    isLoggedIn: function() {
      return this.$store.getters["authPractitioner/isLoggedIn"];
    },
    practitionerLogged() {
      return this.$store.getters["authPractitioner/getPractitioner"];
    },
  },
  async mounted() {
    try {
      let { data } = await this.$http.get("home/get-indicators");
      this.data = data;
    } catch (err) {
      this.data = {};
    }
  },
};
</script>

<style scoped>
.finedTitle {
  font-weight: 900;
  text-shadow: 2px 2px #000000;
}

.social-icon {
  font-size: 21px;
  color: white;
}
.revert-img {
  transform: scaleX(-1);
}
</style>
